import { useContext, useEffect } from 'react';
import { AdContext } from './AdContext';
import { isSSR } from './utils';
export function useAdUnit(provider, unitId, options) {
    const { DaAds  } = useContext(AdContext);
    // In ssr we register on render
    if (isSSR()) {
        DaAds === null || DaAds === void 0 ? void 0 : DaAds.registerUnit(provider, unitId, options);
    }
    // On client we have side effect + kill on unmount
    useEffect(()=>{
        if (!isSSR()) {
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.registerUnit(provider, unitId, options);
        }
        return ()=>{
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.killUnit(unitId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        suppressHydrationWarning: true,
        id: unitId
    };
}
